<template> </template>
<script>
import contactFormMixin from '@/mixins/contactForm';
import Topbar from '@/components/mobile/Topbar';
import Header from '@/components/mobile/Header';
import Contact from '@/components/mobile/ContactForm';
import NextPage from '@/components/mobile/NextPage';
export default {
  name: '',
  props: {},
  components: { Topbar, Contact, Header, NextPage },
  mixins: [contactFormMixin],
  data() {
    return {
      opts: {
        start: 0,
        dir: 'v',
        duration: 500,
        beforeChange: function(currentSlideEl, currenIndex, nextIndex) {
          currentSlideEl.classList.add('out');
        },
        afterChange: function(currentSlideEl, currenIndex) {
          currentSlideEl.previousSibling && currentSlideEl.previousSibling.classList.remove('out');
          currentSlideEl.classList.add('in');
        },
      },
      showContactForm: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    moveNext() {
      this.$refs.fullPage.$fullpage.moveNext();
    },
  },
  created() {},
  mounted() {},
  destroyed() {},
};
</script>
<style lang='scss'>
.page {
  display: flex !important;
  flex-direction: column !important;
  padding: 0.2rem 0.25rem 0;
  transition: transform 0.3s;
  // transform: scale(0.9);
  // .inner {
  //   max-width: 6rem;
  //   margin: 0 auto;
  // }
  // &.out {
  //   transform: scale(0.9);
  // }
  // &.in {
  //   transform: scale(1);
  // }
}
.page-main {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.page-footer {
  margin: 0 0 0.1rem;
  text-align: center;
}
.page-1 {
  text-shadow: 2px 2px rgba($color: #000000, $alpha: 0.53);
  // transform: scale(1);
}
</style>
